module.exports = __webpack_public_path__ + "static/media/icon_custom_location_type_consult_black.905ac704.svg";